var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpedia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 201.19682,
    viewBox: "0 0 264.58333 53.233328",
    id: "svg3486",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3480"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(211.74938,-377.82863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3760",
    transform: "matrix(0.37858848,0,0,0.37858848,-108.06807,260.21727)",
    style: {
      strokeWidth: 2.64139056
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3734",
    style: {
      strokeWidth: 2.64139056
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#191e3b",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 14.97481251,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.41588787
    },
    d: "m -377.62058,1214.5703 c -15.34659,0 -27.70364,12.3496 -27.70364,27.6962 v 338.1154 c 0,15.3466 12.35705,27.6962 27.70364,27.6962 h 212.59714 c 4.0151,0 7.24805,-3.231 7.24805,-7.2461 v -38.7851 c 0,-4.0151 -3.23295,-7.2481 -7.24805,-7.2481 h -180.77929 v -123.6504 h 162.55468 c 4.0151,0 7.2461,-3.2329 7.2461,-7.248 V 1387.25 c 0,-4.0151 -3.231,-7.2461 -7.2461,-7.2461 h -162.55468 v -113.4043 h 180.77929 c 4.0151,0 7.24805,-3.231 7.24805,-7.2461 v -37.5371 c 0,-4.0151 -3.23295,-7.2461 -7.24805,-7.2461 z",
    transform: "scale(0.26458333)",
    id: "rect3505"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#191e3b",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 14.97481251,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.41588787
    },
    d: "m 340.08203,1313.0801 c -50.5854,0 -81.99683,17.4213 -103.02734,46.3867 v -30.2617 c 0,-4.0151 -3.23296,-7.2481 -7.24805,-7.2481 h -43.77539 c -4.01509,0 -7.24805,3.233 -7.24805,7.2481 v 369.125 c 0,4.0151 3.23296,7.248 7.24805,7.248 h 44.53181 c 4.01509,0 7.24805,-3.2329 7.24805,-7.248 v -126.2785 c 19.5117,28.0925 51.13073,44.7242 102.27092,44.7238 86.00626,-7e-4 139.56054,-68.0742 139.56055,-151.937 -6e-5,-83.8628 -52.44704,-151.7583 -139.56055,-151.7583 z m -12.49107,48.8323 c 61.87667,0 92.31958,46.0817 92.31948,102.926 1e-4,56.8444 -30.44281,102.9261 -92.31948,102.9261 -61.87667,0 -92.31958,-46.0817 -92.31948,-102.9261 -1e-4,-56.8443 30.44281,-102.926 92.31948,-102.926 z",
    transform: "scale(0.26458333)",
    id: "rect3515"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#191e3b",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 3.96208572,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.41588787
    },
    d: "m 318.52657,349.76776 h 11.64937 c 1.06232,0 1.91756,0.85523 1.91756,1.91756 v 71.86775 c 0,1.06233 -0.85524,1.91756 -1.91756,1.91756 h -11.64937 c -1.06233,0 -1.91756,-0.85523 -1.91756,-1.91756 v -71.86775 c 0,-1.06233 0.85523,-1.91756 1.91756,-1.91756 z",
    id: "rect3532"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#191e3b",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 3.96208572,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.41588787
    },
    d: "m 318.35951,321.3175 h 11.98346 c 1.06233,0 1.91756,0.85524 1.91756,1.91756 v 11.98389 c 0,1.06232 -0.85523,1.91756 -1.91756,1.91756 h -11.98346 c -1.06232,0 -1.91755,-0.85524 -1.91755,-1.91756 v -11.98389 c 0,-1.06232 0.85523,-1.91756 1.91755,-1.91756 z",
    id: "rect3534"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3546",
    d: "m 257.24596,427.77182 c 13.38406,0 21.695,-4.60939 27.25932,-12.27315 v 8.05429 c 0,1.06232 0.85539,1.91772 1.91772,1.91772 h 11.58224 c 1.06232,0 1.91771,-0.8554 1.91771,-1.91772 V 323.27263 c 0,-1.06233 -0.85539,-1.9177 -1.91771,-1.9177 h -11.78238 c -1.06232,0 -1.91771,0.85537 -1.91771,1.9177 v 36.40486 c -5.54045,-7.24381 -13.52834,-12.25849 -27.05919,-12.25839 -22.75582,1.9e-4 -36.92539,18.01118 -36.92539,40.19988 1e-5,22.1887 13.87661,40.15284 36.92539,40.15284 z m 3.30493,-12.92022 c -16.37153,0 -24.42622,-12.19245 -24.42619,-27.2325 -3e-5,-15.04008 8.05466,-27.23253 24.42619,-27.23253 16.37154,0 24.42623,12.19245 24.4262,27.23253 3e-5,15.04005 -8.05466,27.2325 -24.4262,27.2325 z",
    style: {
      opacity: 1,
      fill: "#191e3b",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 3.96208572,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.41588787
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#191e3b",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 14.97481251,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.41588787
    },
    d: "m 1445.0195,1313.2598 c -87.1135,0 -139.5605,67.895 -139.5605,151.7578 0,83.8628 52.447,151.7578 139.5605,151.7578 50.5855,0 81.9969,-17.4213 103.0274,-46.3867 v 30.4414 c 0,4.015 3.2329,7.248 7.248,7.248 h 43.7754 c 4.0151,0 7.2481,-3.233 7.2481,-7.248 v -135.8125 -135.8125 c 0,-4.015 -3.233,-7.2481 -7.2481,-7.2481 h -43.7754 c -4.015,0 -7.248,3.2331 -7.248,7.2481 v 30.4414 c -21.0305,-28.9654 -52.4419,-46.3867 -103.0274,-46.3867 z m 12.4903,48.832 c 61.8767,0 92.3204,46.0815 92.3203,102.9258 1e-4,56.8443 -30.4436,102.9258 -92.3203,102.9258 -61.8767,0 -92.3185,-46.0815 -92.3184,-102.9258 -10e-5,-56.8443 30.4416,-102.9258 92.3184,-102.9258 z",
    transform: "scale(0.26458333)",
    id: "path3557"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#191e3b",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 3.96208596,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.41588787
    },
    d: "m -29.340328,349.76779 c -1.655345,0 -1.951784,1.30712 -1.200444,2.34248 l 24.6532762,33.76031 -27.0588122,37.25709 c -0.751734,1.03505 -0.454898,2.34299 1.200441,2.34299 h 13.349057 c 1.157779,0 1.759235,-0.39534 2.144055,-0.96324 l 18.4381513,-27.2097 19.2039957,27.2097 c 0.395566,0.56046 0.986277,0.96324 2.144055,0.96324 h 13.859617 c 1.655342,0 1.954996,-1.31001 1.200444,-2.34299 L 11.37915,385.8705 35.877912,352.11027 c 0.75134,-1.03534 0.454901,-2.34248 -1.200444,-2.34248 H 21.589896 c -1.157779,0 -1.758144,0.39557 -2.144055,0.96273 l -16.178857,23.7784 -16.714225,-23.7784 c -0.393511,-0.56192 -0.986276,-0.96273 -2.144055,-0.96273 z",
    id: "rect3567"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#191e3b",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 14.97481251,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.41588787
    },
    d: "m 656.30859,1313.0801 c -87.60148,0 -140.32614,62.9879 -140.32617,151.8476 -4e-5,98.0054 62.32111,151.8478 140.32617,151.8477 94.26626,0 131.4238,-55.4393 133.5,-57.5156 2.38919,-2.3893 1.73942,-6.837 -0.26757,-8.8047 l -27.2461,-26.7129 c -2.00699,-1.9677 -5.8261,-2.2701 -8.46875,0.3945 -1.98999,2.0065 -35.16043,43.934 -89.5,43.9336 -57.7601,0 -86.1917,-35.3853 -90.02065,-87.5156 h 215.23745 c 6.67364,0 7.03821,-5.9344 7.05469,-9.8301 0.44772,-105.8354 -61.05724,-157.6445 -140.28907,-157.6445 z m 0.18946,46.0547 c 52.98191,0 75.17562,31.8589 79.85825,77.2402 H 576.39844 c 6.28959,-44.4881 29.65324,-77.2402 80.09961,-77.2402 z",
    id: "path3599",
    transform: "scale(0.26458333)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3744",
    style: {
      strokeWidth: 2.64139056
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#fddb32",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 3.96208596,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.41588787
    },
    d: "m -247.80404,310.65753 h 73.56999 c 14.43656,0 26.05878,11.62222 26.05878,26.05878 v 73.56956 c 0,14.43656 -11.62222,26.05878 -26.05878,26.05878 h -73.56999 c -14.43657,0 -26.05878,-11.62222 -26.05878,-26.05878 v -73.56956 c 0,-14.43656 11.62221,-26.05878 26.05878,-26.05878 z",
    id: "rect3636"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3738",
    style: {
      strokeWidth: 2.64139056
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#191e3b",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.69996846,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.41588787
    },
    d: "m -238.71566,333.15999 c -1.17116,1e-5 -1.90728,0.26915 -2.5275,0.88935 l -12.55942,12.55946 c -0.23324,0.23319 -0.36427,0.54973 -0.36433,0.87953 -7e-5,0.68662 0.55671,1.24332 1.24334,1.24334 l 54.44577,-1e-5 -33.47186,33.47135 c -0.65963,0.65962 -1.04336,1.04333 -1.04334,2.33782 l -1e-5,8.80671 c 1e-5,0.5333 0.24259,0.99549 0.59066,1.34359 0.34808,0.34806 0.80977,0.59015 1.34308,0.59016 l 8.80721,-1e-5 c 1.29451,0 1.6777,-0.38322 2.33731,-1.04284 l 33.47187,-33.47185 v 54.44575 c 1e-5,0.68663 0.55671,1.24342 1.24333,1.24335 0.32979,-4e-5 0.64638,-0.13107 0.87954,-0.36432 l 12.55944,-12.55942 c 0.62018,-0.62022 0.88941,-1.35632 0.88936,-2.52752 l -2e-5,-59.45166 a 8.3930309,8.3930309 0 0 0 -8.39328,-8.39279 z",
    id: "path3707"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect3709",
    d: "m -249.38273,397.72867 h 12.08089 c 1.01056,0 1.82412,0.81355 1.82412,1.82411 v 12.15651 c 0,1.01056 -0.81356,1.82412 -1.82412,1.82412 h -12.08089 c -1.01056,0 -1.82412,-0.81356 -1.82412,-1.82412 v -12.15651 c 0,-1.01056 0.81356,-1.82411 1.82412,-1.82411 z",
    style: {
      opacity: 1,
      fill: "#191e3b",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 3.96208596,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.41588787
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpedia);
export default __webpack_public_path__ + "static/media/expedia.e4196ecaba9eabf757f2c2270a1f149a.svg";
export { ForwardRef as ReactComponent };